// Tarih işlemleri için yardımcı fonksiyonlar

// Tarih formatlaması (DD.MM.YYYY)
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}.${month}.${year}`;
};

// Tarih ve saat formatlaması (DD.MM.YYYY HH:MM)
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

// Saat formatlaması (HH:MM)
export const formatTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${hours}:${minutes}`;
};

// Yaş hesaplama
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return 0;
  
  const birthDate = new Date(dateOfBirth);
  if (isNaN(birthDate.getTime())) return 0;
  
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

// İki tarih arasındaki dakika farkı
export const getMinutesBetweenDates = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;
  
  // Milisaniye cinsinden fark
  const diffMs = end - start;
  
  // Dakika cinsinden fark
  return Math.floor(diffMs / (1000 * 60));
};

// Başlangıç zamanından şu ana kadar geçen süreyi hesapla
export const getElapsedTime = (startTime) => {
  if (!startTime) return { minutes: 0, display: '0 dk' };
  
  const start = new Date(startTime);
  const now = new Date();
  
  if (isNaN(start.getTime())) return { minutes: 0, display: '0 dk' };
  
  // Milisaniye cinsinden fark
  const diffMs = now - start;
  
  // Dakika cinsinden fark
  const minutes = Math.floor(diffMs / (1000 * 60));
  
  // Saat ve dakika olarak gösterme
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return {
      minutes: minutes,
      display: `${hours} sa ${remainingMinutes} dk`
    };
  } else {
    return {
      minutes: minutes,
      display: `${minutes} dk`
    };
  }
};

// Dakikayı saat:dakika formatına çevirme
export const formatDuration = (minutes) => {
  if (!minutes || isNaN(minutes)) return '0 dk';
  
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours} sa ${remainingMinutes} dk`;
  } else {
    return `${minutes} dk`;
  }
};

// Ne kadar zaman önce formatını hesapla (1 sa önce, 5 dk önce vb.)
export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  const now = new Date();
  const diffMs = now - date;
  
  // Saniye cinsinden fark
  const diffSec = Math.floor(diffMs / 1000);
  
  if (diffSec < 60) {
    return 'Şimdi';
  } else if (diffSec < 3600) {
    const minutes = Math.floor(diffSec / 60);
    return `${minutes} dakika önce`;
  } else if (diffSec < 86400) {
    const hours = Math.floor(diffSec / 3600);
    return `${hours} saat önce`;
  } else {
    const days = Math.floor(diffSec / 86400);
    return `${days} gün önce`;
  }
};

// Süre formatını hesapla (2 saat 15 dakika)
export const formatDurationWithStartAndEnd = (startTimeStr, endTimeStr = null) => {
  if (!startTimeStr) return '';
  
  const startTime = new Date(startTimeStr);
  const endTime = endTimeStr ? new Date(endTimeStr) : new Date();
  
  if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) return '';
  
  const diffMs = endTime - startTime;
  const diffMin = Math.floor(diffMs / (60 * 1000));
  
  const hours = Math.floor(diffMin / 60);
  const minutes = diffMin % 60;
  
  if (hours > 0) {
    return `${hours} saat ${minutes > 0 ? `${minutes} dakika` : ''}`;
  } else {
    return `${minutes} dakika`;
  }
};

// Bugünün tarihini almak
export const getCurrentDateFormatted = () => {
  const now = new Date();
  return formatDate(now);
};

// Bugünün tarih ve saatini almak
export const getCurrentDateTimeFormatted = () => {
  const now = new Date();
  return formatDateTime(now);
};
